import React, { useEffect, useState } from 'react'
import { Badge, Button, Modal } from 'react-bootstrap'
import { getPayoutsRequest, updatePayoutsRequest } from '../../../Services/AdminServices/adminUserServices';
import { LoaderIcon } from 'react-hot-toast';
import DataTables from '../../Main/DataTable/DataTables';
import { FaEye } from "react-icons/fa";

const AdminWithdrawal = () => {

    const [isLoading, setIsLoading] = useState(false)
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])

    // Modal states
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const handleClose = () => setShowModal(false);
    const handleShow = (row) => {
        setSelectedRow(row);
        setShowModal(true);
    };

    const updatePayoutStatus = async (id) => {
        setIsLoading(true);
        let response = await updatePayoutsRequest(id);
        if (response.code === 200) {
            setIsLoading(false);
            payoutRequest();
        } else {
            setIsLoading(false);
        }
    };

    const payoutRequest = async () => {
        setLoading(true);
        let response = await getPayoutsRequest();
        if (response.code === 200) {
            setLoading(false);
            setData(response?.result?.payouts?.original?.data)
        } else {
            setLoading(false);
        }
    };

    useEffect(() => { payoutRequest() }, [])

    const columns = [
        {
            name: 'S.No.',
            selector: (row, index) => index + 1,
            width: '80px',
        },
        { name: 'Email', selector: row => row.user?.email },
        { name: 'Name', selector: row => row?.user?.name },
        { name: 'Account Title', selector: row => row.account_title },
        { name: 'Bank Name', selector: row => row.bank_name },
        { name: 'Account Number', selector: row => row.account_number },
        { name: 'Amount', selector: row => row.amount },
        { name: 'Contact', selector: row => row.contact },
        {
            name: 'Action',
            width: "250px",
            cell: row => (
                <div className="d-flex align-items-center justify-content-center gap-2 flex-nowrap">
                    {/* 👁 Eye Icon for Modal */}
                    <FaEye

                        className="text-muted cursor-pointer"
                        size={18}
                        onClick={() => handleShow(row)}
                        style={{ cursor: "pointer" }}
                    />

                    {row?.status === "Pending" ? (
                        <Button
                            onClick={() => updatePayoutStatus(row?.id)}
                            size='sm'
                            variant='outline-success'
                        >
                            {isLoading ? <LoaderIcon /> : "Approve"}
                        </Button>
                    ) : (
                        <Button size='sm' variant='success'>
                            Approved
                        </Button>
                    )}

                    {row?.status !== "Approved" && (
                        <Button size='sm' variant='outline-danger'>
                            Reject
                        </Button>
                    )}
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        }
    ];

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <h3 className='fw-bold mb-0'>Withdrawal Requests</h3>
                        <p className='text-muted'>Manage user withdrawal requests</p>
                    </div>

                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                            <div className="spinner-border text-info" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <DataTables filter={true} columns={columns} data={data} />
                    )}
                </div>
            </div>

            {/* 👇 Modal for Row Details */}
            <Modal show={showModal} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title className='s-12'>Withdrawal Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedRow && (
                        <div>
                            <p><strong>Email:</strong> {selectedRow.user?.email}</p>
                            <p><strong>Name:</strong> {selectedRow.user?.name}</p>
                            <p><strong>Account Title:</strong> {selectedRow.account_title}</p>
                            <p><strong>Contact:</strong> {selectedRow.contact}</p>
                            <p><strong>Bank Name:</strong> {selectedRow.bank_name}</p>
                            <p><strong>Account Number:</strong> {selectedRow.account_number}</p>
                            <p><strong>Amount:</strong> {selectedRow.amount}</p>
                            <p><strong>Status:</strong> {selectedRow.status}</p>
                            <p><strong>Date:</strong> {selectedRow?.created_at ? new Date(selectedRow.created_at).toLocaleDateString() : "-"}</p>

                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default AdminWithdrawal
